import Box from '@mui/material/Box';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {IAllStates} from '../../../../../store/rootReducer';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import {FaCheck} from 'react-icons/fa';
import {scrollToTopRef} from '../../../../../utils/helpers/ScrollToTop';
import {scrollToBottomRef} from '../../../../../utils/helpers/scrollToBottomRef';
import TabPanel from '@mui/lab/TabPanel';
import {OverviewTab} from '../../../../influencer/offer/modal/offer-modal/tabs/OverviewTab';
import {AgencyContentTab} from './tabs/AgencyContentTab';
import {AgencyDistributionTab} from './tabs/AgencyDistributionTab';
import {AgencyLegalTab} from './tabs/AgencyLegalTab';
import {setActiveTab} from '../../../../../store/agency/agencyOfferSlice';
import {AgencyHistoryTab} from './tabs/AgencyHistoryTab';
import {AgencyOfferTab} from './tabs/offer/AgencyOfferTab';
import {OfferComments} from '../../../../../shared/components/offer-comments/OfferComments';

interface IOfferModalTabProps {
    offerModalRef: React.RefObject<HTMLDivElement>;
}

export function AgencyOfferModalRightSide({offerModalRef}: IOfferModalTabProps) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {
        activeTabModal,
        isStepperFinished,
        campaign,
        hasLegal,
        isLegalChecked,
        isDistributionChecked,
        requiredFieldChangeColor,
        canWriteComment,
        hasUnreadComments,
    } = useSelector((state: IAllStates) => state.offerAgency);
    const isMobile = window.innerWidth <= 700;
    const isNotInitialOffer = !!campaign?.offers[0]?.id;
    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(setActiveTab(+newValue));
        if (requiredFieldChangeColor && activeTabModal === 1) {
            scrollToTopRef(offerModalRef);
        } else if (!isLegalChecked && activeTabModal === 3) {
            scrollToBottomRef(offerModalRef);
        } else if (!isDistributionChecked && activeTabModal === 2) {
            scrollToBottomRef(offerModalRef);
        } else {
            scrollToTopRef(offerModalRef);
        }
    };

    const checkIcon = (tabValue: number) => {
        if (activeTabModal > tabValue || isStepperFinished) {
            return <FaCheck/>;
        }
        return undefined;
    };

    return (
        <>
            <TabContext value={String(activeTabModal)}>
                <Box className="mb-3">
                    <TabList allowScrollButtonsMobile={isMobile} variant={isMobile ? 'scrollable' : 'fullWidth'}
                             onChange={handleTab}>
                        <Tab label={t('influencer.offer_management.modal.overview')}
                             value="0" icon={checkIcon(0)} iconPosition={'end'}/>
                        <Tab label={t('influencer.offer_management.modal.content')}
                             value="1" icon={checkIcon(1)} iconPosition={'end'}/>
                        <Tab label={t('influencer.offer_management.modal.distribution')}
                             value="2" icon={checkIcon(2)} iconPosition={'end'}/>
                        {hasLegal &&
                            <Tab label={t('influencer.offer_management.modal.legal')}
                                 value="3" icon={checkIcon(3)} iconPosition={'end'}/>
                        }
                        <Tab label={t('influencer.offer_management.modal.offer')}
                             value="4"/>
                        {isNotInitialOffer &&
                            <Tab label={t('influencer.offer_management.modal.comments')}
                                 icon={<> {hasUnreadComments && <span className="notification-comment-badge">
                                </span>}</>}
                                 value="5"/>
                        }
                        {campaign?.offerPlaceholder?.flags?.hasHistory &&
                            <Tab label={t('influencer.offer_management.modal.history')}
                                 value="6"/>
                        }
                    </TabList>
                </Box>
                <Box ref={offerModalRef} className="modal-right-content">
                    <TabPanel className="p-0 pb-4" value="0">
                        <OverviewTab campaign={campaign}/>
                    </TabPanel>
                    <TabPanel className="p-0 pb-4" value="1">
                        <AgencyContentTab/>
                    </TabPanel>
                    <TabPanel className="p-0 pb-4" value="2">
                        <AgencyDistributionTab/>
                    </TabPanel>
                    <TabPanel className="p-0 pb-4" value="3">
                        <AgencyLegalTab/>
                    </TabPanel>
                    <TabPanel className="p-0 pb-4" value="4">
                        <AgencyOfferTab/>
                    </TabPanel>
                    {isNotInitialOffer &&
                        <TabPanel className="p-0 h-100" value="5">
                            <OfferComments
                                offerId={campaign?.offers[0]?.id}
                                canWriteComment={canWriteComment}
                            />
                        </TabPanel>
                    }
                    <TabPanel className="p-0" value="6">
                        <AgencyHistoryTab/>
                    </TabPanel>
                </Box>
            </TabContext>
        </>
    );
}